module.exports = __webpack_public_path__ + "img/bets.f5025e5c.png";